import React from 'react'
import { twMerge } from 'tailwind-merge'

function Badge(props: React.PropsWithChildren<any>) {
  return (
    <div
      className={twMerge(
        props.className ||
          'flex items-center rounded-2xl border border-brand-primary/20 px-4 text-xs font-semibold text-brand-primary',
      )}
    >
      {props.children}
    </div>
  )
}

export default Badge
